import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '@shared/providers/AuthContext';

export type TreatmentReportRouteDerivedParams = {
  siteType: string;
  clinicNumber: string;
  patientId: string;
};

/**
 * Treatment report pages derive the effective siteType/clinicNumber/patientId from route params.
 */
export function useTreatmentReportRouteParams(): TreatmentReportRouteDerivedParams {
  const { clinic } = useAuth();
  const { tenant, site, clinic_number, clinicNumber, patientId, id } = useParams();

  return useMemo(() => {
    const tenantStr = tenant || '';
    const parts = tenantStr.split('/');

    const derivedSiteType = site || parts[0] || '';
    const derivedClinicNumber =
      clinic_number || clinicNumber || parts[1] || clinic?.clinic_number || '';
    const derivedPatientId = patientId || id || '';

    return {
      siteType: derivedSiteType,
      clinicNumber: derivedClinicNumber,
      patientId: derivedPatientId,
    };
  }, [tenant, site, clinic_number, clinicNumber, patientId, id, clinic?.clinic_number]);
}
